/*
  log actions are sent to Redux Sagas located in:
  packages\tracs\src\redux\log\saga.js
*/
const actions = {
  LOCATION_FIELDS: 'LOCATION_FIELDS',
  LOCATION_FIELDS_SUCCESS: 'LOCATION_FIELDS_SUCCESS',
  LOCATIONS: 'LOCATIONS',
  LOCATION_SUCCESS: 'LOCATION_SUCCESS',
  LOCATION_CREATE: 'LOCATION_CREATE',
  LOCATION_CREATE_SUCCESS: 'LOCATION_CREATE_SUCCESS',
  LOCATION_UPDATE: 'LOCATION_UPDATE',
  LOCATION_UPDATE_SUCCESS: 'LOCATION_UPDATE_SUCCESS',
  LOCATION_DELETE: 'LOCATION_DELETE',
  LOCATION_DELETE_SUCCESS: 'LOCATION_DELETE_SUCCESS',
  LOCATION_ERROR: 'LOCATION_ERROR',

  apiLocationFields: () => ({
    type: actions.LOCATION_FIELDS,
  }),

  apiLocations: queryString => ({
    type: actions.LOCATIONS,
    queryString,
  }),

  apiLocationCreate: createdLocation => ({
    type: actions.LOCATION_CREATE,
    createdLocation,
  }),

  apiLocationUpdate: updatedLocation => ({
    type: actions.LOCATION_UPDATE,
    updatedLocation,
  }),

  apiLocationDelete: deletedLocation => ({
    type: actions.LOCATION_DELETE,
    deletedLocation,
  }),
};
export default actions;
